import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Packages() {
  return <section id="packages" className="section-padding bg-off-white" data-id="element-262">
      <div className="container-custom" data-id="element-263">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-264">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-6" data-id="element-265">
            Choose the Consulting Package That Fits the Business
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12" data-id="element-266">
          {/* Tier 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white border border-steel p-8 md:p-10 rounded-sm flex flex-col" data-id="element-267">
            <div className="mb-8 border-b border-steel pb-8" data-id="element-268">
              <h3 className="text-2xl font-bold font-heading text-navy mb-2" data-id="element-269">
                Tier 1 / Engaged
              </h3>
              <div className="text-4xl font-black font-heading text-navy mb-4" data-id="element-270">
                $5,000
                <span className="text-xl text-body/50 font-medium" data-id="element-271">/mo</span>
              </div>
              <p className="text-body/80 text-sm leading-relaxed" data-id="element-272">
                <strong className="text-navy" data-id="element-273">Best for:</strong> focused
                one-on-one leadership support and implementation through a
                dedicated internal point of contact.
              </p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-274">
              {['Dedicated strategy and implementation cadence', 'Customized project plan', 'Focused support across core bottlenecks', 'Best for owners who can delegate internally'].map((bullet, i) => <li key={i} className="flex items-start" data-id="element-275">
                  <CheckCircle2 className="w-5 h-5 text-red shrink-0 mr-3 mt-0.5" data-id="element-276" />
                  <span className="text-body/90" data-id="element-277">{bullet}</span>
                </li>)}
            </ul>

            <a href="#contact" className="btn-primary w-full" data-id="element-278">
              Discuss Tier 1
            </a>
          </motion.div>

          {/* Tier 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-navy text-white border border-navy p-8 md:p-10 rounded-sm flex flex-col relative overflow-hidden shadow-xl" data-id="element-279">
            {/* Accent top bar */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-red" data-id="element-280"></div>

            <div className="mb-8 border-b border-white/10 pb-8" data-id="element-281">
              <h3 className="text-2xl font-bold font-heading text-white mb-2" data-id="element-282">
                Tier 2 / Committed
              </h3>
              <div className="text-4xl font-black font-heading text-white mb-4" data-id="element-283">
                $10,000
                <span className="text-xl text-white/50 font-medium" data-id="element-284">/mo</span>
              </div>
              <p className="text-white/80 text-sm leading-relaxed" data-id="element-285">
                <strong className="text-white" data-id="element-286">Best for:</strong> companies that
                need FleetScale engaged with the full leadership team and
                multiple operational stakeholders.
              </p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-287">
              {['Full leadership-team engagement', 'Multiple points of contact', 'Cross-functional process design', 'Stronger fit for larger or more complex operations'].map((bullet, i) => <li key={i} className="flex items-start" data-id="element-288">
                  <CheckCircle2 className="w-5 h-5 text-amber shrink-0 mr-3 mt-0.5" data-id="element-289" />
                  <span className="text-white/90" data-id="element-290">{bullet}</span>
                </li>)}
            </ul>

            <a href="#contact" className="btn-primary w-full" data-id="element-291">
              Discuss Tier 2
            </a>
          </motion.div>
        </div>

        <div className="text-center max-w-2xl mx-auto bg-steel/30 p-6 rounded-sm border border-steel/50" data-id="element-292">
          <p className="text-body/80 text-sm font-medium" data-id="element-293">
            Not sure which tier fits? Start with the free consultation and
            FleetScale will help identify the right path.
          </p>
        </div>
      </div>
    </section>;
}